import { render, staticRenderFns } from "./ExtendUpdate.vue?vue&type=template&id=27cc9a11&scoped=true&"
import script from "./ExtendUpdate.vue?vue&type=script&lang=js&"
export * from "./ExtendUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cc9a11",
  null
  
)

export default component.exports